import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconDocument = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
        data-fill-none
      >
        <rect
          width="24"
          height="24"
          rx="4"
          fill="#F7F2FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.56298 5.95215C6.52161 5.95215 6.48193 5.96858 6.45267 5.99784C6.42342 6.0271 6.40698 6.06677 6.40698 6.10815V17.8891C6.40698 17.9305 6.42342 17.9702 6.45267 17.9995C6.48193 18.0287 6.52161 18.0451 6.56298 18.0451H17.438C17.4794 18.0451 17.519 18.0287 17.5483 17.9995C17.5775 17.9702 17.594 17.9305 17.594 17.8891L17.596 7.85028C17.596 7.85025 17.596 7.85031 17.596 7.85028C17.596 7.82948 17.5918 7.8088 17.5837 7.78964C17.5758 7.77091 17.5643 7.75391 17.5499 7.73959L15.7348 5.99659C15.7057 5.96816 15.6667 5.9522 15.626 5.95215M5.39201 4.93718C5.70257 4.62662 6.12378 4.45215 6.56298 4.45215H15.626C16.0572 4.45224 16.4714 4.6205 16.7804 4.92107L18.5952 6.66375C18.7536 6.81802 18.8796 7.00248 18.9656 7.20622C19.0516 7.40996 19.0959 7.62886 19.096 7.85001L19.094 17.8891C19.094 17.8891 19.094 17.8892 19.094 17.8891C19.0939 18.3283 18.9195 18.7496 18.609 19.0601C18.2984 19.3707 17.8772 19.5451 17.438 19.5451H6.56298C6.12378 19.5451 5.70257 19.3707 5.39201 19.0601C5.08145 18.7496 4.90698 18.3283 4.90698 17.8891V6.10815C4.90698 5.66895 5.08145 5.24774 5.39201 4.93718ZM15.626 5.95215H6.56298H15.626Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 11.9209C8.25 11.5067 8.58579 11.1709 9 11.1709H15.36C15.7742 11.1709 16.11 11.5067 16.11 11.9209C16.11 12.3351 15.7742 12.6709 15.36 12.6709H9C8.58579 12.6709 8.25 12.3351 8.25 11.9209Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 8.9209C8.25 8.50668 8.58579 8.1709 9 8.1709H11.359C11.7732 8.1709 12.109 8.50668 12.109 8.9209C12.109 9.33511 11.7732 9.6709 11.359 9.6709H9C8.58579 9.6709 8.25 9.33511 8.25 8.9209Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 14.9209C8.25 14.5067 8.58579 14.1709 9 14.1709H15.25C15.6642 14.1709 16 14.5067 16 14.9209C16 15.3351 15.6642 15.6709 15.25 15.6709H9C8.58579 15.6709 8.25 15.3351 8.25 14.9209Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  })
);
